import * as React from "react";
const SvgFiRrInhaler = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-inhaler_svg__a)">
      <path
        fill="#062147"
        d="M3 12.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 3 12.5M1.5 16a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 1.5 16m0 5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 1.5 21m4-7.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 13.5m0 5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 18.5M23.947 3.56l-2.729 14.373A5 5 0 0 1 16.306 22h-4.305c-1.654 0-3-1.346-3-3v-3c0-1.654 1.346-3 3-3h.97l1.928-9.774A4.01 4.01 0 0 1 18.823 0H21c.896 0 1.739.396 2.311 1.087a2.99 2.99 0 0 1 .636 2.473m-7.087.053L16.192 7h5.066l.724-3.813a.99.99 0 0 0-.212-.824.99.99 0 0 0-.77-.362h-2.177c-.953 0-1.778.678-1.962 1.613zM20.878 9h-5.081l-1.024 5.193a1 1 0 0 1-.981.807H12c-.551 0-1 .449-1 1v3c0 .551.449 1 1 1h4.305a3 3 0 0 0 2.947-2.44z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-inhaler_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInhaler;
